import $ from "jquery";
import {
  canModifyProjectByProjectId,
  canModifyProjectByRoomId,
  ControllerGlobals,
  deepCopy,
  genericXHRErrorHandler,
  getAuthHeader,
  getTextFromHtmlString,
  MODKEYS_STATE,
  startLoading,
  stopLoading,
  toastError,
  toastErrorSingle,
  toastInfo,
  toastInfoSingle,
  toastNotProError
} from "src/components/Planner/controller";
import {
  getDeviceById,
  getFrameWidth,
  getRoomById,
  getSerialById,
  getSerialOfDeviceId,
  getSerObj,
  ghostDevProps,
  isPointOutOfBounds,
  isThereCameraPlaced,
  rebuildWallsCache,
  thereWasGhostDevice,
  uDev,
  UDevGlobals,
  whichRoomIsPointIn
} from "src/components/Planner/planner/uDev";
import {
  getProductOfDevice,
  getProductTargetSerialStrategy,
  modDevNote,
  sendDevNote,
  sendSoleNote
} from "src/components/Planner/planner/uDev-dom";
import {
  CreateSerialAction,
  DeleteSerialAction,
  DeleteSingleDeviceAction
} from "src/components/Planner/planner/history/device-actions";
import {GlobalsVariables, ROOT_URI} from "src/utils/constants";
import * as d3 from "d3";
import {
  distToSegment,
  doesDeviceFitRoom,
  P_numtoxy,
  P_xytonum,
  snapDeviceToWall,
  uMath,
  wallClosestPointToPoint,
  XYtoNumPoly
} from "src/components/Planner/planner/uMath";
import {snapDeviceToNearby} from "src/components/Planner/planner/deviceGeometry";
import {isCamera, isProdCamera, isProdDreamMachine} from "src/components/Planner/planner/movsen";
import {ts} from "src/utils/translate";
import {CreateSoleNoteAction} from "src/components/Planner/planner/history/note-actions";
import {WIFICALC} from "src/components/Planner/planner/wificalc";
import {wifiheatmap} from "src/components/Planner/planner/wificalc-dom";
import {placeDevice, redrawDevice, removeDevice} from "src/components/Planner/planner/deviceDrawing";
import {measureHelper, toggleMeasurements} from "src/components/Planner/planner/measurement";
import {entitySelectClick, entitySelectUpdate} from "src/components/Planner/planner/wallModHelper-dom";
import {mouseupGroup, recalcSwitchPNIDs} from "src/components/Planner/planner/grouping";
import {GroupDeviceAction} from "src/components/Planner/planner/history/group-actions";
import {PLANNER_WIZARD} from "src/components/Planner/planner/wizard";
import {DeleteRoomAction} from "src/components/Planner/planner/history/room-actions";
import {DeleteOuterWallsAction} from "src/components/Planner/planner/history/outerwall-actions";
import {
  addHaventExited,
  addPlaceDeviceAction,
  adjustCenter,
  AnyLineIntersectsARoomMod,
  AnyLineIntersectsSelfMod,
  checkAndPanDraw,
  CleanupAll,
  closeWizListDelay,
  draw_mouseMove,
  drawCleanup,
  eventShouldntTriggerHotkey,
  getXY,
  getXYCorrig,
  getXYP,
  groupingSave,
  handleLongPress,
  hasUserMovedMouse,
  hideRotateAndDeviceTools,
  hideTools,
  highlightNextProblematic,
  highlightPoint,
  highlightRoom,
  initPlannerTooltips,
  isBlockingModalOpen,
  isNumArr,
  isPlannerBusy,
  isPlannerImperial,
  isPointAvailable,
  modifyDelete,
  modifyWallsOfRoom,
  mouseUpHandler,
  openWizList,
  permissionCheck,
  plannerHoverMouseOut,
  plannerHoverMouseOver,
  putDrawCircle,
  redrawDrawcircles,
  redrawModifyCircles,
  redrawModifyPolyline,
  removeGhostDevice,
  removeLengthLines,
  requireLeavingToolbarOnce,
  roomContainsAnother,
  roomModifySave,
  rotateMeEnd,
  rotateMeUndo,
  selectRoom,
  setMode,
  setPageXY,
  setPlannerCallbacks,
  toggleDeviceSize,
  toggleEditableWallViewMode,
  toggleGrid,
  toggleOpacity,
  togglePlanNames,
  toggleSymbols,
  undoErrorCorrectMode,
  unHighlight,
  wasClickValidForMustClick,
  zenModeOff,
  zenModeOn
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {getDColsNum, getDRowsNum} from "src/components/Planner/planner/serial-layout";
import {
  areThereNotes,
  deleteNote,
  setDevNote,
  setNoteCallbacks,
  toggleNotes
} from "src/components/Planner/planner/notes";
import {mouseMoveDraggedDevHandler, setDragDropCallbacks} from "src/components/Planner/planner/draganddrop";
import {
  calcOuter,
  deleteOuterWalls,
  instantCalcOuter,
  modifyOuterWallSave
} from "src/components/Planner/planner/outerwall";
import {canSerializeProdWithSerials, getSerialBBox_NoDOM} from "src/components/Planner/planner/serialConnections";
import {
  highlightAvailableSerials,
  placeSerialDevices,
  removeSerialDevices
} from "src/components/Planner/planner/serialConnections-dom";
import {deviceProvider} from "src/components/Planner/planner/DeviceProvider";
import {isCategoryLocked} from "src/components/Planner/planner/categoryDisplayHandler";
import {genericAlertSwal, genericOKCancelSwal} from "src/utils/swal";
import {createHeightTouchspin} from "src/utils/touchspin";
import {setDeviceToolsCallbacks} from "src/components/Planner/planner/deviceTools";

export function initGlobalEvents(
    onCustomItemDrop,
    onReplaceDevice,
    onBulkDeleteDevice,
    onSelectDevice,
    onEditFrame,
    onFrameAction,
    onChangeDesign,
    onNoteDrop,
    onNoteEdit,
    onNoteEditOnDevice,
    onNoteAddToDevice,
    onSelectRoom,
    onScaleSaved,
    onFullscreenChange
) {
  if (PlannerGlobals.isInQuote) {
    return;
  }

  setDeviceToolsCallbacks({ onReplaceDevice, onEditFrame, onChangeDesign });
  setDragDropCallbacks({ onFrameAction });
  setPlannerCallbacks({ onBulkDeleteDevice, onSelectDevice, onScaleSaved, onFullscreenChange });
  setNoteCallbacks({ onNoteEdit, onNoteEditOnDevice, onNoteAddToDevice });

  var longPressTimeout;
  var hasLongPressed;
  var longPressDownFired;
  var longPressStartElement;

  $(window).off('keyup.planner');
  $(window).on('keyup.planner', function (e) {
    longPressDownFired = false;

    if (eventShouldntTriggerHotkey(e)) {
      return;
    }

    if (e.originalEvent.key == 'Delete' || e.originalEvent.keyCode == 8
        || e.originalEvent.keyCode == 46) {

      if (longPressTimeout) {
        clearTimeout(longPressTimeout);
      }
      var busyReason = isPlannerBusy();
      if (busyReason) {
        toastInfo(busyReason);
        return;
      }
      if (!hasLongPressed) {
        if (PlannerGlobals.currentlySelectedElement && longPressStartElement
            === PlannerGlobals.currentlySelectedElement) {
          var type = PlannerGlobals.currentlySelectedElement.type;
          if (type === "device") {
            var deviceId = PlannerGlobals.currentlySelectedElement.content.deviceId;
            var dev = getDeviceById(deviceId);
            if (dev && !UDevGlobals.devIsChangingTo[dev.deviceId]) {
              removeDevice(this, deviceId)
              .done(function (params) {
                var action = new DeleteSingleDeviceAction(params);
                PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
              });
            }
          } else if (type === "serial") {
            var ser = getSerialById(
                PlannerGlobals.currentlySelectedElement.content.id);
            if (ser) {
              var prods = ser.deviceIds.map(function (did) {
                return deviceProvider.getDeviceByProductNameId(getDeviceById(did).product_name_id);
              });

              var firstDev = getDeviceById(ser.deviceIds[0]);
              var x = firstDev.x;
              var y = firstDev.y;
              var angle = firstDev.angle;
              var roomId = firstDev.roomId;

              removeSerialDevices(ser.id)
              .done(function (removedDevParams, removedMeasures, serConn) {
                var action = new DeleteSerialAction(x, y, roomId, angle, prods,
                    ser.id, removedDevParams, removedMeasures, serConn,
                    ser.height, ser.direction);
                PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
              });
            }
          }
        }
      }
    }

    if (['drawing', 'prepareSelect', 'basic', 'showImportants',
      'wallSelect', 'wallSelectModify', 'measurePrepare',
      'entitySelect', 'drawOuterW', 'wificalc', 'groupMe',
      'showBuildingMats'].indexOf(PlannerGlobals.mode) !== -1) {

      var actions = {
        'Escape': function () {

          // Don't allow ESC when in fullscreen scale mode (zen + wallSelect)
          if (
              PlannerGlobals.PLANNER_ZEN_MODE &&
              (
                  PlannerGlobals.mode === 'wallSelect' ||
                  PlannerGlobals.mode === 'wallSelectModify')
          ) {
            return;
          }
          setMode.basic();
        },
        '9': function () {
          return '#toggle-wallselect-btn';
        },
        '1': function () {
          return '#toggle-drawouter-btn';
        },
        '2': function () {
          return '#toggle-drawing-btn';
        },
        '3': function () {
          return '#toggle-doorselect-btn';
        },
        '4': function () {
          return '#toggle-windowselect-btn';
        },
        '5': function () {
          return "#measure-distance-btn";
        },
        '6': function () {
          return "#set-wall-types-btn";
        },
        'o': function () {
          return '#toggle-opacity-btn';
        },
        'a': function () {
          return "#toggle-plannames-btn";
        },
        'd': function () {
          return "#measure-toggle-btn";
        },
        'e': function () {
          return "#toggle-symbols-btn";
        },
        'n': function () {
          return "#toggle-notes-btn";
        },
        'w': function () {
          return '#wificalc-btn';
        },
        'l': function () {
          return GlobalsVariables.env === "dev" ? '#toggle-lighting-btn' : '';
        },
        'q': function () {
          return '#show-build-mat-btn';
        },
        'g': function () {
          return '#show-grid';
        },
      }

      if (e.key in actions) {
        const elem = $(actions[e.key]());
        if (elem.css('visibility') === "hidden") {
          return;
        }
        elem.trigger('click');
      }
    } else if (PlannerGlobals.mode == 'selectRoom') {
      if (e.key === 'Enter') { //enter
        if (!$('.sweet-alert').is(':visible')) {
          // var tourstep = localStorage.getItem('tour_current_step');
          // if (tourstep && tourstep == 19 && tour && !tour.ended()) return;
          roomModifySave();
        }
      } else if (e.key === 'Escape') { //escape
        if (!$('.sweet-alert').is(':visible')) {
          $('#undo-modify-btn').click();
        }
      }
    } else if (PlannerGlobals.mode == 'modifyOuterW') {
      if (e.key === 'Enter') { //enter
        $('#confirm-modify-btn').click();
      } else if (e.key === 'Escape') { //escape
        $('#undo-modify-btn').click();
      }
    } else if (PlannerGlobals.mode == 'grouping') {
      if (e.key === 'Enter') {
        groupingSave();

      } else if (e.key === 'Escape') {
        setMode.prepareGrouping();
      }
    } else if (PlannerGlobals.mode == 'wizard') {
      if (e.key === 'Enter') {
        $('#confirm-modify-btn').click();
      } else if (e.key === 'Escape') {
        $('#undo-modify-btn').click();
      }
    } else if (PlannerGlobals.mode === 'rotateMe' && e.key === 'Escape') {
      rotateMeUndo();
    } else if (PlannerGlobals.mode === 'wallSegmentation') {
      if (e.key === 'Escape') {
        PlannerGlobals.wallSegmentation.revert();
      } else if (e.key === 'Enter') {
        PlannerGlobals.wallSegmentation.finish();
      }
    }
  });

  var deleteTimeout = null;

  $(window).off('keydown.planner');
  // ctrl+v ctrl v ctrl-v clipboard insert
  $(window).on('keydown.planner', function (e) {
    if (PlannerGlobals.isInQuote || isBlockingModalOpen()) {
      // do nothing
      return;
    } else if (e.originalEvent.ctrlKey || e.originalEvent.metaKey) {
      if (e.originalEvent.key.toLowerCase() == "v" && PlannerGlobals.mode
          == 'basic') {
        unHighlight();
        var elems = document.querySelectorAll(':hover');
        if (PlannerGlobals.clipboard.type) {

          var mouseTarget = $(elems[elems.length - 1]);
          var xy = getXYCorrig();
          var closestSerial = mouseTarget.closest('.serial');

          if (PlannerGlobals.clipboard.type == 'device') {
            /**
             * @type {Device}
             */
            var pastedDev = PlannerGlobals.clipboard.content;
            var pastedProduct = Object.assign({},
                getProductOfDevice(pastedDev));
            if (isCategoryLocked(+pastedProduct.parent.replace('category_', ''))) {
              return;
            }

            if (closestSerial.length > 0) { // placing in serial
              var ser = getSerialById(
                  d3.select(closestSerial[0]).attr('data-serialId'));
              var dev = getDeviceById(ser.deviceIds[0]);
              var develem = $('[data-deviceId=' + dev.deviceId + ']')[0];
              ControllerGlobals.currentlyDraggedDevice = pastedProduct;
              deviceDropOnDevice(develem, xy[0], xy[1]);
              ControllerGlobals.currentlyDraggedDevice = null;
            } else if (mouseTarget.is('polygon') || mouseTarget.is('.polyt')) { // placing on blank space, NOT serial
              var room = getRoomById(
                  d3.select(mouseTarget[0]).attr('data-roomId'));

              if (doesDeviceFitRoom(uDev.UNASSIGNED_ROOM_ID, P_numtoxy(xy),
                  pastedDev.angle, 1, 1)) {
                room = uDev.VIRTUAL_UNASSIGNED_ROOM;
              }

              rebuildWallsCache(room);
              ControllerGlobals.currentlyDraggedDevice = pastedProduct;
              var snapped = snapDeviceToNearby(getXYP(), pastedProduct, false);
              if (!snapped) {
                snapped = snapDeviceToWall(getXYP(),
                    PlannerGlobals.DEVICE_SIZE * 1.5);
              }
              /*if (isCamera(pastedDev)) {
                                snapped = null;
                            }*/
              ControllerGlobals.currentlyDraggedDevice = null;
              if (snapped && isCamera(pastedDev)) {
                snapped.rotation += 90;
                snapped.rotation %= 360;
              }
              const placeAt = snapped ? {
                x: snapped.point.x,
                y: snapped.point.y,
                roomId: snapped.room.id,
                angle: snapped.rotation,
              } : {
                x: xy[0],
                y: xy[1],
                roomId: room.id,
                angle: pastedDev.angle,
              };
              if (pastedDev.noteTxt) {
                pastedProduct.note_message = pastedDev.noteTxt;
              } else {
                pastedProduct.prevent_note = true;
              }
              placeDevice(placeAt.x, placeAt.y, placeAt.roomId, pastedProduct,
                  addPlaceDeviceAction(true, null),
                  true, null, placeAt.angle, undefined, undefined, true)
            }
          } else if (PlannerGlobals.clipboard.type == 'serial') {
            const serial = PlannerGlobals.clipboard.content;
            const serObj = getSerObj(serial);

            if (mouseTarget.is('polygon') || mouseTarget.is('.polyt')) {
              var room = getRoomById(
                  d3.select(mouseTarget[0]).attr('data-roomId'));

              const cols = getDColsNum(serObj);
              const rows = getDRowsNum(serObj);

              var corrXy = [xy[0] - getFrameWidth(cols) / 2
              + PlannerGlobals.DEVICE_SIZE / 2, xy[1]];
              if (doesDeviceFitRoom(uDev.UNASSIGNED_ROOM_ID, P_numtoxy(corrXy),
                  serial.angle, cols, rows)) {
                room = uDev.VIRTUAL_UNASSIGNED_ROOM;
              }

              var snapped = snapDeviceToWall(getXYP(),
                  PlannerGlobals.DEVICE_SIZE * 1.2 + (Math.max(cols, rows) - 1)
                  * PlannerGlobals.DEVICE_SIZE * 0.6, cols, false,
                  undefined, undefined, undefined, undefined, rows);

              var prods = serial.deviceIds.map(function (devId) {
                const dev = getDeviceById(devId);
                const prod = Object.assign({},
                    deviceProvider.getDeviceByProductNameId(dev.product_name_id));
                if (dev.noteTxt) {
                  prod.note_message = dev.noteTxt;
                } else {
                  prod.prevent_note = true;
                }
                return prod;
              });

              const placeAt = snapped ? {
                x: snapped.point.x,
                y: snapped.point.y,
                roomId: snapped.room.id,
                angle: snapped.rotation,
              } : {
                x: corrXy[0],
                y: corrXy[1],
                roomId: room.id,
                angle: serial.angle,
              };
              placeSerialDevices(placeAt.x, placeAt.y, placeAt.roomId, prods,
                  placeAt.angle, undefined, serial.height, serial.direction)
              .done(function (serial) {
                if (serial) {
                  var action = new CreateSerialAction(placeAt.x, placeAt.y,
                      placeAt.roomId, placeAt.angle, prods, serial.id,
                      serial.height, serial.direction);
                  PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
                }
              });
            }
          } else if (PlannerGlobals.clipboard.type == 'note') {
            // if dev but not cabinet
            if (PlannerGlobals.lastDevIdMouseOver
                && PlannerGlobals.lastDevIdMouseOver.indexOf('S_') !== 0) {
              var dev = this.getDeviceById(PlannerGlobals.lastDevIdMouseOver);
              if (dev /* && PNIDHasDefaultNote(dev.product_name_id) */) {
                var strId = dev.deviceId + "";
                var type = strId.indexOf('C_') === 0 ? 3 : 2;
                if (dev.noteTxt) {
                  genericOKCancelSwal(ts("p_note_overwrite_confirm",
                          "Do you want to overwrite this device's note with the copied one?"),
                      "Ok",
                      function () {
                        modDevNote(dev, PlannerGlobals.clipboard.content.color,
                            PlannerGlobals.clipboard.content.text);
                      });
                } else {
                  sendDevNote(type, PlannerGlobals.clipboard.content.color,
                      PlannerGlobals.clipboard.content.text, strId, dev);
                }
              }
            } else {
              var xycenter = getXYP();
              if (xycenter.x >= -100 && xycenter.x <= 1000 && xycenter.y >= -100
                  && xycenter.y <= 1000) {
                sendSoleNote(xycenter.x, xycenter.y,
                    PlannerGlobals.clipboard.content.text,
                    PlannerGlobals.clipboard.content.color, function (note) {
                      if (note) {
                        var action = new CreateSoleNoteAction(note.note_id,
                            note.x, note.y, note.text, note.color);
                        PlannerGlobals.plannerHistoryManager.addHistoryEntry(
                            action);
                      }
                    });
                hideTools();
              }
            }
          }
        }

      } else if (e.originalEvent.key.toLowerCase() == "c") {
        if (PlannerGlobals.currentlySelectedElement) {
          if (!('item_type' in PlannerGlobals.currentlySelectedElement.content)
              || PlannerGlobals.currentlySelectedElement.content.item_type
              == "custom_item") {
            PlannerGlobals.clipboard = PlannerGlobals.currentlySelectedElement;
            toastInfoSingle(
                ts('p_copied', 'Element copied', false, 'elem-copied-toast'));
          }
          if ('item_type' in PlannerGlobals.currentlySelectedElement.content) {
            var findStr = typeof PlannerGlobals.currentlySelectedElement.content.type
            === "string"
                ? PlannerGlobals.currentlySelectedElement.content.type.replace(
                    " ", "_") : "";
            let text = deviceProvider.getCabinetName(PlannerGlobals.currentlySelectedElement.content.item_type);
            if (text) {
              toastError(ts('tree_only_one_product_error',
                  'You can only have one {0} per floor.',
                  [{template: '{0}', value: text}]));
            }
          }
        }
      } else if (e.originalEvent.key.toLowerCase() == "z") {
        $('#planner-undo-btn').click();
      } else if (e.originalEvent.key.toLowerCase() == "y") {
        $('#planner-redo-btn').click();
      }
    } else if (e.originalEvent.key == 'Delete' || e.originalEvent.keyCode == 8
        || e.originalEvent.keyCode == 46) { // in case of mac 8->backspace, 46->delete

      if (eventShouldntTriggerHotkey(e)) {
        return;
      }
      if (longPressDownFired) {
        return;
      }
      longPressDownFired = true;
      var busyReason = isPlannerBusy();
      if (busyReason) {
        toastInfo(busyReason);
        return;
      }
      if (PlannerGlobals.currentlySelectedElement) {
        longPressStartElement = PlannerGlobals.currentlySelectedElement;
        var type = PlannerGlobals.currentlySelectedElement.type;
        var deviceId;
        if (type == 'device') {
          deviceId = PlannerGlobals.currentlySelectedElement.content.deviceId;
        } else if (type == 'serial'
            && PlannerGlobals.currentlySelectedElement.actualClickedDevId) {
          deviceId = PlannerGlobals.currentlySelectedElement.actualClickedDevId;
        }
        hasLongPressed = false;
        if (deviceId) {
          longPressTimeout = setTimeout(function () {
            if (longPressStartElement
                === PlannerGlobals.currentlySelectedElement) {
              hasLongPressed = true;
              handleLongPress(deviceId);
            }
          }, 600);
          return;
        } else if (type == 'note') {
          deleteNote(PlannerGlobals.currentlySelectedElement.content.id,
              PlannerGlobals.currentlySelectedElement.content.type);
          unHighlight();
        }
      }
    }
  });

  PlannerGlobals.lastDevIdMouseOver = null;
  PlannerGlobals.lastNoteIdMouseOver = null;

  $(document).off('mouseover', plannerHoverMouseOver);
  $(document).on('mouseover', plannerHoverMouseOver);

  $(document).off('mouseout', plannerHoverMouseOut);
  $(document).on('mouseout', plannerHoverMouseOut);

  $(window).on('resize', function () {
    if ($('#plannerSVG').length) {
      adjustCenter();
    }
  });

  document.removeEventListener('mouseup', mouseUpHandler);
  document.addEventListener('mouseup', mouseUpHandler);

  /* $('#plannerSVG').on('touchstart touchmove', function (e) {
        e.preventDefault();
    }); */
  $('#plannerSVG').off('mousemove.planner')
  $('#plannerSVG').on('mousemove.planner', function (e) {
    e.preventDefault();

    mouseMoveDraggedDevHandler(e);

    if (PlannerGlobals.mode == 'wificalc' && wifiheatmap) {
      var xy = getXYP();
      var str = wifiheatmap.getValueAt(xy);
      var cont = $('#signal-strength');
      if (str > 0) {
        cont.show();
        var numStr = str;
        var strStr;
        if (numStr > 80) {
          strStr = ts('p_wifi_excellent', 'Excellent');
        } else if (numStr > 25) {
          strStr = ts('p_wifi_good', 'Good');
        } else {
          strStr = ts('p_wifi_ok', 'OK');
        }
        $('#signal-strength-value').html(strStr);
        cont.css('left', e.clientX - cont.width() / 2)
        .css('top', e.clientY - cont.height() - 15);
      } else {
        cont.hide();
      }
    }
  });

  function hideSigStr() {
    $('#signal-strength').hide();
  }

  $(window).off('blur', hideSigStr);
  $(window).on('blur', hideSigStr);

  $('#plannerSVG').off('mouseleave', hideSigStr);
  $('#plannerSVG').on('mouseleave', hideSigStr);

  $('#wizard-btn-dropdown').on('mouseenter', function () {
    openWizList();
  });

  $('#wizard-btn-dropdown').on('mouseleave', function () {
    // if (!(newTour.isOngoing() && newTour.currStepId === "wizard")) {
    closeWizListDelay(500);
    // }
  });

  initPlannerTooltips();

  $('#plannerSVG').on('dblclick', '.poly', function (e) {
    var roomId = d3.select(this).attr("data-roomId");

    // If already editing a room or outer wall, exit edit mode instead of switching
    if (PlannerGlobals.mode == 'selectRoom' || PlannerGlobals.mode == 'modifyOuterW') {
      $('#undo-modify-btn').click();
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    }

    if (roomId == uDev.OUTDOORS_ROOM_ID) {
      if (uDev.outerBorderExists()) {
        PlannerGlobals.selectRoomBeginMatSaveState = PlannerGlobals.wallSegmentation.getSaveData();
        setMode.modifyOuterW();
      }
    } else if (roomId) {
      if (!canModifyProjectByRoomId(roomId)) {
        toastNotProError();
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }
      PlannerGlobals.selectRoomBeginMatSaveState = PlannerGlobals.wallSegmentation.getSaveData();
      setMode.prepareSelect();
      highlightRoom(roomId);
      selectRoom(roomId);
      onSelectRoom?.(Number(roomId));
    }
    e.stopImmediatePropagation();
    e.preventDefault();
  });

  if (PlannerGlobals.drawPanInterval) {
    clearInterval(PlannerGlobals.drawPanInterval);
  }
  PlannerGlobals.drawPanInterval = setInterval(checkAndPanDraw,
      PlannerGlobals.DRAW_PAN_TIME);
  $(document).on("mousemove mousedown mouseup", setPageXY);

  function deviceDropOnDevice(target, x, y) {
    setMode.basic();
    //getting the target room, device, and serial
    var roomId = d3.select(target).attr('data-roomId');
    var targetDevId = d3.select(target).attr('data-deviceId');
    var targetDev = getDeviceById(targetDevId);
    if (targetDev.ghost || targetDev.attachingDev) {
      return;
    }
    var serialOfTargetDev = getSerialOfDeviceId(targetDevId);

    const strat = getProductTargetSerialStrategy(
        ControllerGlobals.currentlyDraggedDevice, serialOfTargetDev);
    let angle = undefined;
    //if the serial of target is full, we don't place the device
    console.log(strat);

    if (strat.targetSerial && strat.targetSerial.deviceIds.length >= 5) {
      toastErrorSingle(`${ts('doesnt_fit_serial_warning',
          'doesntFitSerialWarning')} (${getTextFromHtmlString(
          ControllerGlobals.currentlyDraggedDevice.text)})`);
      return;
      //if the device is not serializable, we put it on the top of the target device
    }

    if (!canSerializeProdWithSerials(ControllerGlobals.currentlyDraggedDevice,
        strat.targetSerial)) {
      toastErrorSingle('You can\'t drop more device to this serial');
      return;
    }
    if (strat.connectTo) {
      const serBBox = getSerialBBox_NoDOM(strat.connectTo.id);
      if (serBBox) {
        x = serBBox.rotateCenter.x - PlannerGlobals.DEVICE_SIZE / 2 + 0.001;
        y = serBBox.rotateCenter.y - PlannerGlobals.DEVICE_SIZE / 2 + 0.001;
        angle = serBBox.angle;
      }
    }
    const tarDevs = serialOfTargetDev ? serialOfTargetDev.deviceIds.map(
        getDeviceById) : [targetDev];

    tarDevs.forEach(dev => dev.attachingDev = true);

    placeDevice(x, y, roomId, ControllerGlobals.currentlyDraggedDevice,
        (newDev, resp, ser, newAddonDev) => {
          return addPlaceDeviceAction(strat.alone, strat.targetSerial,
              strat.connectTo)(newDev, resp, ser, newAddonDev)
          .finally(() => {

            tarDevs.forEach(dev => dev.attachingDev = false);
            redrawDevice(targetDevId);

            if (ControllerGlobals.currentlyDraggedDevice
                && MODKEYS_STATE.shift) {
              highlightAvailableSerials(
                  ControllerGlobals.currentlyDraggedDevice);
            }
          });
        }, strat.alone, strat.targetSerial, angle, !!strat.connectTo, undefined,
        true);
  }

  // placing currently dragged device
  $('#plannerSVG').on('mouseup', function (e) {
    if (!wasClickValidForMustClick(e).clickValid) {
      return;
    }

    if (PlannerGlobals.mode == 'entitySelect' && e.which == 3) {
      if (e.originalEvent.buttons & 1 == 1) {
        // left click is pressed
        PlannerGlobals.entitySelectPreventOnce = true;
      }
    }
    if (PlannerGlobals.mode == "measureMe") {
      measureHelper.endMeasure(e);
    }
    removeLengthLines();
    // don't handle any mouse clicks, but left mouse
    if (e.button != 0) {
      return;
    }
    if (e.which == 1) {
      if (PlannerGlobals.entitySelectPreventOnce) {
        PlannerGlobals.entitySelectPreventOnce = false;
      } else {
        entitySelectUpdate();
        var finished = entitySelectClick(e);
      }
    }

    if (ControllerGlobals.currentlyDraggedDevice) {
      var busyReason = isPlannerBusy();
      if (busyReason) {
        toastInfo(busyReason);
        return;
      }
    }

    //the target of the event, expected to be a room or a device
    var target = $(e.target);
    if (target[0].nodeName == 'rect') {
      if (!(ControllerGlobals.currentlyDraggedDevice
          && ControllerGlobals.currentlyDraggedDevice.id === "new_note")) {
        var parent = $(target[0].parentNode);
        if (parent.hasClass('serial') || parent.hasClass('serial-connected')) {
          target = parent.find('.device').first();
          e.target = target[0];
        }
      }
    }
    var targetType = target.attr("class");
    //the coordinates of the mouse up event
    var xy = getXYCorrig();
    var x = xy[0], y = xy[1];

    var disablePlacingBecausePlanMoved = MODKEYS_STATE.shift
        && hasUserMovedMouse(1);

    var tarIsCab = target.hasClass('device') && target.attr(
        'data-deviceId').indexOf('S_') === 0;

    const fitsUnassigned = doesDeviceFitRoom(uDev.UNASSIGNED_ROOM_ID, {x, y}, 0,
        1, 1);

    if (!disablePlacingBecausePlanMoved
        && ControllerGlobals.currentlyDraggedDevice
        && ControllerGlobals.currentlyDraggedDevice.id === "new_note"
        && (!target.hasClass('device') || tarIsCab)) {
      var noteXY = {
        x: uMath.clamp(x + PlannerGlobals.DEVICE_SIZE / 2, -100, 1000),
        y: uMath.clamp(
            y + PlannerGlobals.DEVICE_SIZE / 2 + PlannerGlobals.DEVICE_SIZE / 6,
            -100, 1000)
      };

      var roomId = d3.select(e.target).attr("data-roomId");
      if (roomId == null) {
        removeGhostDevice();
        return;
      }
      const isModify = canModifyProjectByRoomId(roomId);
      if (!isModify) {
        toastNotProError();
        return;
      }

      removeGhostDevice();
      onNoteDrop?.({
        x: noteXY.x,
        y: noteXY.y,
        floorId: PlannerGlobals.plannerFloorId,
      });
    } else if (thereWasGhostDevice() && ControllerGlobals.currentlyDraggedDevice
        && !disablePlacingBecausePlanMoved) {
      let ghostProps = ghostDevProps();
      if (ControllerGlobals.currentlyDraggedDevice.id == "new_custom_device") {
        onCustomItemDrop?.({
          x: ghostProps.x,
          y: ghostProps.y,
          roomId: ghostProps.roomId,
          rot: ghostProps.rot
        });
      } else {
        if (isProdCamera(ControllerGlobals.currentlyDraggedDevice)) {
          ghostProps.rot += 90;
          ghostProps.rot %= 360;
        }
        var gpSave = ghostProps;
        var cddSave = ControllerGlobals.currentlyDraggedDevice;
        var placeDevCb = function () {
          placeDevice(gpSave.x, gpSave.y, gpSave.roomId, cddSave,
              (newdev, resp, ser, newAddon) =>
                  addPlaceDeviceAction(true, null)(newdev, resp, ser,
                      newAddon).finally(() => {
                    if (ControllerGlobals.currentlyDraggedDevice
                        && MODKEYS_STATE.shift) {
                      highlightAvailableSerials(
                          ControllerGlobals.currentlyDraggedDevice);
                    }
                  }),
              true, null, gpSave.rot, undefined, undefined, true);
        };
        if (isThereCameraPlaced() && isProdDreamMachine(
            ControllerGlobals.currentlyDraggedDevice)) {
          genericOKCancelSwal(ts("p_dm_cam",
                  "By using the Dream Machine you won't be able to record the camera video. Do you want to continue?"),
              "OK", function () {
                placeDevCb();
              });
        } else {
          placeDevCb();
        }
      }
    }
    //if the target is a device (serializing)
    else if (target.hasClass('device')
        && ControllerGlobals.currentlyDraggedDevice
        && !disablePlacingBecausePlanMoved && !tarIsCab) {
      if (ControllerGlobals.currentlyDraggedDevice.id === "new_note") {
        var devId = d3.select(e.target).attr("data-deviceId");
        setDevNote(devId);
      } else if (ControllerGlobals.currentlyDraggedDevice.id
          != "new_custom_device") {
        deviceDropOnDevice(e.target, x, y);
      }
    }
    //if the target is a room (placing a new device)
    else if ((target.hasClass('poly') || target.hasClass('polyt')
            || fitsUnassigned) && ControllerGlobals.currentlyDraggedDevice
        && !disablePlacingBecausePlanMoved) {
      //get the target room
      var roomId = fitsUnassigned ? uDev.UNASSIGNED_ROOM_ID : d3.select(
          e.target).attr("data-roomId");
      setMode.basic();

      if (ControllerGlobals.currentlyDraggedDevice.id == "new_custom_device") {
        onCustomItemDrop?.({ x: x, y: y, roomId: roomId, rot: 0 });
      } else {
        var cddSave = ControllerGlobals.currentlyDraggedDevice;
        var placeDevCb = function () {
          placeDevice(x, y, roomId, cddSave, (newdev, resp, ser, newAddon) =>
              addPlaceDeviceAction(true, null)(newdev, resp, ser,
                  newAddon).finally(() => {
                if (ControllerGlobals.currentlyDraggedDevice
                    && MODKEYS_STATE.shift) {
                  highlightAvailableSerials(
                      ControllerGlobals.currentlyDraggedDevice);
                }
              }), true, null, undefined, undefined, undefined, true);
        };

        if (isThereCameraPlaced() && isProdDreamMachine(
            ControllerGlobals.currentlyDraggedDevice)) {
          genericOKCancelSwal(ts("p_dm_cam",
                  "By using the Dream Machine you won't be able to record the camera video. Do you want to continue?"),
              "OK", function () {
                placeDevCb();
              }, "OK");
        } else {
          //simply place the device in the room
          placeDevCb();
        }
      }
    }
    // if it's currently grouping mode and the target was a device, we try to group them together
    else if (PlannerGlobals.mode == 'groupMe') {
      if (target.hasClass('device')) {
        var targetDeviceId = d3.select(e.target).attr('data-deviceId');
        var srcId = PlannerGlobals.groupMeSourceId;
        mouseupGroup(srcId, targetDeviceId, function () {
          var action = new GroupDeviceAction(srcId, targetDeviceId);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          recalcSwitchPNIDs();
        });
      }
      setMode.basic(true);
    } else if (PlannerGlobals.mode == 'rotateMe') {
      rotateMeEnd();
    }
    /* else if (mode == 'wallSelect') {
            wallSelectEnd();
        } */
    else if (ControllerGlobals.currentlyDraggedDevice
        && !disablePlacingBecausePlanMoved) {
      if (!whichRoomIsPointIn({x: x, y: y})) {
        if (isPointOutOfBounds({x, y})) {
          toastErrorSingle(ts('p_dev_out_of_bounds_err',
                  'Make sure the device is inside the area marked by the dashed lines.'),
              false, 'dev-place-err');
        } else {
          toastErrorSingle(ts('p_dev_wall_intersect_err',
                  "Make sure the device doesn't intersect any walls."), false,
              'dev-place-err');
        }
      }
    } else if (!(ControllerGlobals.currentlyDraggedDevice
        && MODKEYS_STATE.shift)) {
      unHighlight();
    }

    if (ControllerGlobals.currentlyDraggedDevice && MODKEYS_STATE.shift) {
      removeGhostDevice();
    }

  });

  // inserting a room point on a wall; on click, so a plan pan doesn't insert one
  $('#plannerSVG').on('click', function (e) {
    if (e.button != 0 || !wasClickValidForMustClick(e).clickValid) {
      return;
    }
    var target = $(e.target);
    if (!PlannerGlobals.modifying || PlannerGlobals.draggingRoomCircle
        || !(target.attr("id") == "plannerIMAGE"
            || target.attr("id") == "outdoorPoly")) {
      return;
    }

    var realXY = getXY();
    var room = PlannerGlobals.modifiedRoom;
    var walls = modifyWallsOfRoom(room);
    var minDist = Number.POSITIVE_INFINITY;
    var minWall = 0;
    // getting closest wall to cursor
    for (var i = 0; i < walls.length; i++) {
      var dist = distToSegment({x: realXY[0], y: realXY[1]},
          {x: walls[i].x1, y: walls[i].y1}, {x: walls[i].x2, y: walls[i].y2});
      if (dist < minDist) {
        minDist = dist;
        minWall = i
      }
    }
    // check if the distance is smaller than a given amount
    if (minDist > 2) {
      return;
    }

    PlannerGlobals.changedWalls[walls[minWall].id + ""] = true;
    // overwrite point to be exactly on the wall
    realXY = P_xytonum(
        wallClosestPointToPoint(P_numtoxy(realXY), walls[minWall]));
    // if there's already a point placed there, return
    for (var segIdx = 1; segIdx <= 2; segIdx++) {
      let distFromExisting = uMath.pointDistance(P_numtoxy(realXY),
          uMath.nThSegmentPoint(walls[minWall], segIdx));
      if (distFromExisting < 0.1) {
        return;
      }
    }

    // insert new point
    PlannerGlobals.modifiedPoly.splice(minWall + 1, 0,
        {x: realXY[0], y: realXY[1]});
    var normalModroomPoly = XYtoNumPoly(PlannerGlobals.modifiedPoly);
    // check if room isn't breaking any rules
    if (!isPointAvailable(realXY) ||
        AnyLineIntersectsSelfMod() ||
        AnyLineIntersectsARoomMod() ||
        PlannerGlobals.mode != 'modifyOuterW' && roomContainsAnother(
            normalModroomPoly) ||
        PlannerGlobals.mode == 'selectRoom' && roomContainsAnother(
            normalModroomPoly)) {
      // if invalid, remove point
      PlannerGlobals.modifiedPoly.splice(minWall + 1, 1);
    } else {
      // if valid, keep it, and make it undo-able
      PlannerGlobals.selectRoomUndoArr.push(minWall);
    }
    redrawModifyCircles();
    redrawModifyPolyline();
  });

  $('#toggle-drawing-btn').click(function (e) {
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }
    if (PlannerGlobals.mode != 'drawing') {
      PlannerGlobals.selectRoomBeginMatSaveState = PlannerGlobals.wallSegmentation.getSaveData();
      setMode.drawing();
      addHaventExited(e);
      // if (!newTour.isOngoing()) {
      toastInfo(
          ts('p_shift_wallangle', 'Hold the Shift bar to draw in any angle.'));
      // }
    } else {
      setMode.basic();
    }
  });

  $('#toggle-drawouter-btn').click(function (e) {
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }
    if (PlannerGlobals.mode == 'drawOuterW' || PlannerGlobals.mode
        == 'modifyOuterW') {
      setMode.basic();
    } else {
      if (uDev.outerBorderExists()) {
        PlannerGlobals.selectRoomBeginMatSaveState = PlannerGlobals.wallSegmentation.getSaveData();
        setMode.modifyOuterW();
      } else {
        setMode.drawOuterW();
        addHaventExited(e);
      }
    }
  });

  $('#toggle-prepareSelect-btn').click(function (e) {
    if (PlannerGlobals.mode == 'prepareSelect' || PlannerGlobals.mode
        == 'selectRoom') {
      setMode.basic();
    } else {
      setMode.prepareSelect();
    }
  });

  // CROP BTNS START
  $('#crop-rot-ccw').click(function (e) {
    PlannerGlobals.editPictureHelper.changePictureRot(
        PlannerGlobals.editPictureHelper.pictRot - 1);
  });

  $('#crop-rot-cw').click(function (e) {
    PlannerGlobals.editPictureHelper.changePictureRot(
        PlannerGlobals.editPictureHelper.pictRot + 1);
  });

  $('#crop-zoom-in').click(function (e) {
    PlannerGlobals.editPictureHelper.increaseScale();
  });

  $('#crop-zoom-out').click(function (e) {
    PlannerGlobals.editPictureHelper.decreaseScale();
  });

  $('#crop-reset-all').click(function (e) {
    PlannerGlobals.editPictureHelper.resetAll();
  });

  $('#crop-confirm').click(function (e) {
    PlannerGlobals.editPictureHelper.renderToBlob(function (imageBlob) {
      if (imageBlob) {
        var URLObj = window.URL || window.webkitURL;
        var objUrl = URLObj.createObjectURL(imageBlob);

        // TODO: moveplannercode-alignfloorplan
        // openModfloorModal();

        $('#modify-floor-modal .fileinput').removeClass(
            'fileinput-new').addClass('fileinput-exists');
        $('#modify-floor-modal .fileinput-preview').html(
            '<img src="' + objUrl + '">');
        $('#modify-floor-modal .fileinput-preview img').data('blob', imageBlob);

        toastInfo(ts("p_crop_nosave_tip",
            "Your changes are not saved yet. Press the \"Modify floor\" button to confirm modifications."));
        PlannerGlobals.editPictureHelper.restoreModalProps();
        $('#modal-modify-floor-form input[name="floor_name"]').select();
      } else {

      }
    });
  });

  $('#crop-cancel').click(function (e) {
    // TODO: moveplannercode-alignfloorplan
    // openModfloorModal();
    PlannerGlobals.editPictureHelper.restoreModalProps();
    $('#modal-modify-floor-form input[name="floor_name"]').select();
  });
  // CROP BTNS END

  $('#toggle-wallselect-btn').click(function (e) {
    if (!permissionCheck(this)) {
      return;
    }
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }

    if (PlannerGlobals.mode == 'wallSelect' || PlannerGlobals.mode
        == 'wallSelectModify') {
      zenModeOff();
      setMode.basic()
    } else {
      setMode.wallSelect();
      addHaventExited(e);
    }
  });

  $('#toggle-doorselect-btn').click(function (e) {

    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }

    if (PlannerGlobals.mode == 'entitySelect' && PlannerGlobals.entitySelectType
        == 'door') {
      setMode.basic();
    } else {
      setMode.doorSelect();
      addHaventExited(e);
    }
  });

  $('#toggle-windowselect-btn').click(function (e) {

    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }

    if (PlannerGlobals.mode == 'entitySelect' && PlannerGlobals.entitySelectType
        == 'window') {
      setMode.basic();
    } else {
      setMode.windowSelect();
      addHaventExited(e);
    }
  });

  $('#planner-visual-toggler').click(function (e) {
    var target = $('#planner-buttons-visual');
    var icon = $(this).find('i');
    if (target.hasClass('planner-buttons-cont-out')) {
      // show menu
      target.css('position', 'relative');
      target.removeClass('planner-buttons-cont-out');
      icon.removeClass('fa-caret-right').addClass('fa-caret-left');
      $(this).css({background: '#dfdfdf', border: '#dfdfdf'});
    } else {
      // hide menu
      target.addClass('planner-buttons-cont-out');
      icon.removeClass('fa-caret-left').addClass('fa-caret-right');
      $(this).css({background: '', border: ''});
      setTimeout(function () {
        target.css('position', 'absolute');
      }, 200);
    }
  });

  $('#toggle-opacity-btn').click(function (e) {
    toggleOpacity();
  });

  // new wizard btns
  $('#wiz-drop-item-smart').click(function (e) {
    $('#wiz-drop-subs-smart').toggleClass('hidden');
    $('#lox-drop-arrow').toggleClass('rotate180');
    if (!$('#wiz-drop-subs-smart').hasClass('hidden')) {
      $('#wiz-drop-subs-conventional').addClass('hidden');
      $('#conv-drop-arrow').removeClass('rotate180');
    }
  });

  $('#wiz-drop-item-conventional').on('click', function () {
    $('#wiz-drop-subs-conventional').toggleClass('hidden');
    $('#conv-drop-arrow').toggleClass('rotate180');
    if (!$('#wiz-drop-subs-conventional').hasClass('hidden')) {
      $('#wiz-drop-subs-smart').addClass('hidden');
      $('#lox-drop-arrow').removeClass('rotate180');
    }
  });

  $('.wiz-drop-subcateg').click(function (e) {
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }
    var $this = $(this);
    var bundle = $this.attr('data-bundle');
    var config = $this.attr('data-config');
    instantCalcOuter(function () {
      PLANNER_WIZARD.start(bundle, config);
    });
  });

  $('#wiz-drop-item-leaf').click(function (e) {
    instantCalcOuter(function () {
      PLANNER_WIZARD.start("leaf");
    });
  });

  var $comfortStarContainer = $('#planner-comfort-stars');

  function regenComfortVal() {
    $comfortStarContainer.attr('data-value', PlannerGlobals.comfortLevel);
    $comfortStarContainer.find('i')
    .each(function () {
      var $this = $(this);
      if (+$this.attr('data-value') <= PlannerGlobals.comfortLevel) {
        $this.addClass('fa-star').removeClass('fa-star-o');
      } else {
        $this.addClass('fa-star-o').removeClass('fa-star');
      }
    });
  }

  regenComfortVal();

  $comfortStarContainer.find('i').bindFirst('mousedown', function (e) {
    e.preventDefault();
  });

  $comfortStarContainer.find('i').bindFirst('click', function (e) {
    var $this = $(this);
    var thisLevel = +$this.attr('data-value');
    if (thisLevel == PlannerGlobals.comfortLevel) {
      return;
    }
    var projId = PlannerGlobals.plannerProjectId;
    startLoading();

    getAuthHeader(function (headers) {
      $.ajax({
        headers,
        url: ROOT_URI + '/project/set-wizard-project-properties',
        method: 'POST',
        data: {project_id: projId, comfort_level_id: thisLevel},
        success: function (resp) {
          PlannerGlobals.comfortLevel = thisLevel;
          regenComfortVal()
          stopLoading();
        },
        error: function (resp) {
          genericXHRErrorHandler(resp);
          stopLoading();
        }
      });
    });
    e.stopImmediatePropagation();
  });

  $('#wiz-drop-item-it').on('click', function (e) {
    instantCalcOuter(function () {
      PLANNER_WIZARD.start("it");
    });
  });

  $('#wiz-drop-item-aio').on('click', function (e) {
    instantCalcOuter(function () {
      PLANNER_WIZARD.start("aio");
    });
  });

  $('#outerwall-btn').on('click', function (e) {
    calcOuter(PlannerGlobals.rooms, 35, 0.7, true);
  });

  $('#wificalc-btn').on('click', function (e) {
    setMode.wificalc();
    requireLeavingToolbarOnce();
  });

  $('#show-build-mat-btn').on('click', () => {
    if (PlannerGlobals.mode === "showBuildingMats") {
      if (PlannerGlobals.plannerEditableWallViewEnable === true) {
        toggleEditableWallViewMode(true);
      }
      setMode.basic();
    } else {
      if (PlannerGlobals.plannerEditableWallViewEnable === true) {
        toggleEditableWallViewMode(false);
      }
      setMode.showBuildingMats();
    }
  });

  $('[id^="planner-devsize"]').click(function (e) {
    if (!permissionCheck(this)) {
      return;
    }
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    hideRotateAndDeviceTools();
    unHighlight();
    toggleDeviceSize();
  });

  $('#toggle-grouping-btn').click(function (e) {
    if (PlannerGlobals.mode == 'prepareGrouping' || PlannerGlobals.mode
        == 'grouping') {
      setMode.basic();
    } else {
      setMode.prepareGrouping();
    }
  });

  $('#toggle-importants-btn').click(function (e) {
    if (PlannerGlobals.mode == 'showImportants') {
      setMode.basic();
    } else {
      setMode.showImportants();
    }
  });

  $('#confirm-modify-btn').off();
  $('#confirm-modify-btn').click(function (e) {
    if (PlannerGlobals.mode == 'selectRoom') {
      roomModifySave();
    } else if (PlannerGlobals.mode == 'modifyOuterW') {
      modifyOuterWallSave();
    } else if (PlannerGlobals.mode == 'grouping') {
      groupingSave();
    } else if (PlannerGlobals.mode == 'wizard') {
      PLANNER_WIZARD.acceptChanges();
    } else if (PlannerGlobals.mode == 'wallSegmentation') {
      PlannerGlobals.wallSegmentation.finish();
      if (typeof WIFICALC === "object" && WIFICALC && typeof WIFICALC.reset
          === "function") {
        WIFICALC.reset();
      }
    }
  });

  $('#undo-modify-btn').click(function (e) {
    if (PlannerGlobals.mode == 'selectRoom') {
      if (PlannerGlobals.modifiedRoom.needSend) {
        setMode.drawing();
      } else {
        //setMode.prepareSelect();
        setMode.basic();
      }
    } else if (PlannerGlobals.mode == 'modifyOuterW') {
      setMode.basic();
    } else if (PlannerGlobals.mode == 'grouping') {
      setMode.prepareGrouping();
    } else if (PlannerGlobals.mode == 'wizard') {
      PLANNER_WIZARD.declineChanges();
    } else if (PlannerGlobals.mode == 'wallSegmentation') {
      PlannerGlobals.wallSegmentation.revert();
    }
  });

  $('#delete-modify-btn').click(function (e) {
    if (PlannerGlobals.mode == 'selectRoom') {
      genericAlertSwal(ts('p_room_delete_request',
          "Confirm deleting room by clicking OK button below"), function () {
        var modroom = deepCopy(PlannerGlobals.modifiedRoom);
        const wssd = PlannerGlobals.wallSegmentation.getSaveData();
        modifyDelete(
            function (d3Devs, wallModconns, groups, measurements, serConns) {
              var action = new DeleteRoomAction(modroom, d3Devs, wallModconns,
                  groups, measurements, wssd, serConns);
              PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
              setMode.basic();
              PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
            });
      }, true);
    } else if (PlannerGlobals.mode == 'modifyOuterW') {
      var origiOuter = deepCopy(PlannerGlobals.outerBorder);
      const wssd = PlannerGlobals.wallSegmentation.getSaveData();
      deleteOuterWalls(function (d3Devs/* d3Devs, groups, serConns */) {
        setMode.basic();
        var action = new DeleteOuterWallsAction(origiOuter, d3Devs, []/* groups */,
            wssd, []/* serConns */);
        PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
      });
    }
  });

  $('#planner-undo-btn').click(function (e) {
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      undoErrorCorrectMode();
    } else {
      if (PlannerGlobals.mode !== "basic") {
        setMode.basic();
      }
      if (PlannerGlobals.mode === "basic"
          && PlannerGlobals.plannerHistoryManager) {
        PlannerGlobals.plannerHistoryManager.undo();
      }
    }
  });

  $('#planner-redo-btn').click(function (e) {
    if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      if (PlannerGlobals.mode !== "basic") {
        setMode.basic();
      }
      if (PlannerGlobals.mode === "basic"
          && PlannerGlobals.plannerHistoryManager) {
        PlannerGlobals.plannerHistoryManager.redo();
      }
    }
  });

  $('#planner-history-reset-btn').click(function (e) {
    if (!PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
      if (PlannerGlobals.mode !== "basic") {
        setMode.basic();
      }
      if (PlannerGlobals.mode === "basic"
          && PlannerGlobals.plannerHistoryManager) {
        PlannerGlobals.plannerHistoryManager.resetHistory();
      }
    }
  });

  $('#zen-mode-on-btn').click(function (e) {
    zenModeOn();
  });

  $('#zen-mode-off-btn').click(function (e) {
    zenModeOff();
  });

  //start drawing
  $('#start-drawing-btn').click(function (e) {
    setMode.drawing();
  });

  //stop drawing
  $('#stop-drawing-btn').click(function (e) {
    drawCleanup();
  });

  $('#delete-mode-btn').click(function (e) {
    CleanupAll();
    setMode.edit();
  });

  $('#comment-mode-btn').click(function (e) {
    CleanupAll();
    setMode.comment();
  });

  $('#new-group-btn').click(function (e) {

  });

  $('#toggle-plannames-btn').click(function (e) {
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    togglePlanNames();
  });

  $('#measure-distance-btn').click(function (e) {
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }
    if (PlannerGlobals.mode == "measurePrepare") {
      setMode.basic();
    } else {
      setMode.measurePrepare();
      addHaventExited(e);
    }
  });

  $('#set-wall-types-btn').click(function (e) {
    var projId = PlannerGlobals.plannerProjectId;
    if (!canModifyProjectByProjectId(projId)) {
      return;
    }
    if (PlannerGlobals.mode == "wallSegmentation") {
      setMode.basic();
    } else {
      setMode.wallSegmentation();
    }
  });

  $('#measure-toggle-btn').click(function (e) {
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    toggleMeasurements();
  });

  $('#toggle-symbols-btn').click(function (e) {
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    toggleSymbols();
  });

  $('#toggle-notes-btn').click(function (e) {
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    if (areThereNotes()) {
      toggleNotes();
    } else {
      toastInfoSingle(ts('p_note_notfound',
          "You haven't added any notes to this plan yet. Try using the New Note function in the Device Tree."));
    }
  });

  $('#toggle-grid-btn').click(function (e) {
    if (PlannerGlobals.mode == "showBuildingMats") {
      setMode.basic();
    }
    toggleGrid();
  });

  // click event for drawing
  PlannerGlobals.svg.on('click', function (e) {
    const clickAreaState = wasClickValidForMustClick(e);
    if (!clickAreaState.clickValid) {
      return;
    }

    const origiPointsLen = PlannerGlobals.drawRoomPoints.length;
    putDrawCircle(e);
    const couldDrawPt = PlannerGlobals.drawRoomPoints.length > origiPointsLen;

  });

  // right click event for undoing placing a dot
  // rightclick mouseright mouse right
  PlannerGlobals.svg.on('contextmenu', function (e) {
    e.preventDefault();

    const clickAreaState = wasClickValidForMustClick(e);
    if (!clickAreaState.clickValid) {
      return;
    }

    if (PlannerGlobals.isDrawing) {
      //if (!drawing) return;
      PlannerGlobals.drawRoomPoints.pop();
      if (PlannerGlobals.drawRoomPoints.length == 0) {
        setMode.basic();
      }

      PlannerGlobals.drawRoomStartPoint = PlannerGlobals.drawRoomPoints[PlannerGlobals.drawRoomPoints.length
      - 1];
      draw_mouseMove();

      d3.select('polyline').remove();

      if (PlannerGlobals.g) {
        var polyline = PlannerGlobals.g.append('polyline')
        .attr('points', PlannerGlobals.drawRoomPoints)
        .style('fill', 'none')
        .attr('stroke',
            PlannerGlobals.mode == 'drawOuterW' ? 'darkorange' : 'red')
        .attr('stroke-width', 1);

        redrawDrawcircles();
      }
    } else if (PlannerGlobals.modifying) {
      if (PlannerGlobals.selectRoomUndoArr.length == 0) {
        return;
      }
      var toDeleteIdx = PlannerGlobals.selectRoomUndoArr.pop();
      PlannerGlobals.modifiedPoly.splice(toDeleteIdx + 1, 1);
      redrawModifyCircles();
      redrawModifyPolyline();
    } else if (PlannerGlobals.mode == "measurePrepare") {
      var t = d3.zoomTransform(PlannerGlobals.svg.node());
      var trans = [t.x, t.y];
      if (isNumArr(trans) && isNumArr(PlannerGlobals.mouseDownTranslate) &&
          uMath.pointDistance(P_numtoxy(trans),
              P_numtoxy(PlannerGlobals.mouseDownTranslate)) > 5
          * PlannerGlobals.scalevar) {
        return;
      }
      setMode.basic();
    } else if (PlannerGlobals.mode == "entitySelect") {
      if (PlannerGlobals.entitySelectStartPos) {
        setMode.entitySelect(PlannerGlobals.entitySelectType);
      } else {
        setMode.basic();
      }
    } else if (PlannerGlobals.mode == "rotateMe") {
      rotateMeUndo();
    }
  });

  $('#reset-center-btn').click(function (e) {
    highlightPoint(450, 450, 1);
    setTimeout(function () {
      $('#reset-center-btn').addClass('hidden');
    }, 400);
    //container.attr("transform", "translate(0,0)scale(1)");
    adjustCenter();
    var sliderElem = document.getElementById('size-slider');
    if (sliderElem) {
      var slider = sliderElem.noUiSlider;
      if (slider) {
        slider.set(0);
      }
    }
    PlannerGlobals.prevTranslate = [0, 0];
    PlannerGlobals.prevScale = 1;
    PlannerGlobals.scalevar = 1;
    PlannerGlobals.translatevar = [0, 0];
  });

  $('#show-next-bad-btn').click(function () {
    PlannerGlobals.sizeErrorHelper.userZoomed = false;
    highlightNextProblematic();
    $('#show-next-bad-btn').addClass('hidden');
  });

  let measureUnit = "cm";
  let measureStep = 10;
  if (isPlannerImperial()) {
    measureUnit = "ft";
    measureStep = 1;
  }
  createHeightTouchspin('#height-modify-input', undefined, undefined, undefined,
      measureUnit, measureStep);
}